import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import loadInfluencerWinRates from '../../actions/tips/loadInfluencerWinRates';
import useDispatch from '../../hooks/useDispatch';
import useRegion from '../../hooks/useRegion';
import {
  influencerTipsCols,
  renderIntervalFilter,
} from '../../modules/Tips/TipsPage';
import { TipsModel } from '../../reducers/tips.reducer';
import DLTable from '../table/DLTable/DLTable';
import WinPercentageModal from './InfluencerWinPercentageModal';

const intervals = ['1d', '3d', '5d', '1m', '3m', '1y'];

interface Props {
  data: TipsModel[];
  noDataMessage?: string;
  showInfluencerCol?: boolean;
}

const TipsTemporalTable: React.FC<Props> = ({
  data,
  noDataMessage,
  showInfluencerCol,
}) => {
  const [t] = useTranslation();
  const [winPercentageInterval, setWinInterval] = useState<string>('1d');
  const [isShowWinModal, setWinModalState] = useState<boolean>(false);
  const [winPercentageInfluencerName, setWinPercentageInfluencerName] =
    useState<string>('');
  const dispatch = useDispatch();
  const region = useRegion();

  let columns = influencerTipsCols(
    t,
    winPercentageInterval,
    renderIntervalFilter(intervals, t, setWinInterval, winPercentageInterval),
    (influencerId, name) => {
      setWinModalState(true);
      dispatch(loadInfluencerWinRates(region, influencerId));
      setWinPercentageInfluencerName(name);
    }
  );

  if (!showInfluencerCol) {
    columns = columns.filter(item => item.id !== 'tips-influencer');
  }

  return (data || []).length > 0 ? (
    <div className="tips-temporal-table">
      <WinPercentageModal
        show={isShowWinModal}
        onHide={() => {
          setWinModalState(false);
        }}
        influencerName={winPercentageInfluencerName}
      />
      <DLTable tableId="tips-temporal" columns={columns} data={data} />
    </div>
  ) : (
    <div>{noDataMessage || t('stock-no-tips-history')}</div>
  );
};

export default TipsTemporalTable;
